.ClearBoth {
    clear: both;
    height: 0px;
}

.HiddenPanel {
    display: none;
}

:host {
  display: block;
  padding: 0px;
}

:host div.MapView {
    width: 260px;
    height: 120px;
}

:host div.MapLocationName {
    position: absolute;
    top: 6px;
    right: 10px;
    font-weight: bold;
    color: #22007f;
}

:host div.NarrativeContent {
    padding: 12px;
    padding: 12px 12px 10px 12px;
    font-size: 0.8em;
    overflow-y: scroll;
    height: 260px;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}

:host div.NarrativeContent::-webkit-scrollbar {
    display: none;
}

:host div.PartnerTitle {
    font-weight: bold;
    margin-top: 0px;
}

:host div.CaseId {
    margin-top: 0px;
    margin-bottom: 8px;
}

:host div.NarrativeContent ion-chip:first-of-type {
    position: relative;
}

:host div.NarrativeContent ion-chip {
    position: relative;
    margin-top: 2px;
    margin-left: 0px;
    background-color: rgb(245, 247, 255);
    cursor: default;
}

:host div.NarrativeContent ion-label {
    font-size: 0.7em;
}

:host div.CaseDescription {
    margin-bottom: 5px;
}
